import Cookies from 'js-cookie';

export async function createSessionUserCookie(uuid) {
    try {
        Cookies.set('user_id', uuid, {
            secure: true,
            sameSite: 'strict',
            path: '/'
        });

        return { ok: true };
    } catch (err) {
        return { ok: false, message: "Er ging iets mis bij opslaan van de gebruikerssessie." };
    }
}